import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { OptionsCheckbox } from 'owa-options-controls';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import * as React from 'react';
import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import selectLocaleOption from '../data/mutators/selectLocaleOption';
import setRenameFoldersOption from '../data/mutators/setRenameFoldersOption';
import strings from 'owa-strings/owa-options-strings';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var styles = require('./Regional.scss');
var CultureSelection = /** @class */ (function (_super) {
    tslib_1.__extends(CultureSelection, _super);
    function CultureSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CultureSelection.prototype.render = function () {
        var store = getRegionalOptions();
        return (React.createElement("div", null,
            React.createElement(Dropdown, { label: strings.option_regional_language, options: store.supportedCultures.map(function (culture) { return ({
                    text: culture.NativeName,
                    key: culture.Name,
                }); }), selectedKey: store.selectedLocale || getUserConfiguration().SessionSettings.UserCulture, onChanged: this.onSelectLocale }),
            store.selectedLocale !== null &&
                store.selectedLocale !== getUserConfiguration().SessionSettings.UserCulture && (React.createElement(OptionsCheckbox, { className: styles.renameFolders, onChange: this.toggleRenameFolders, label: strings.option_regional_renameDefaultFolders, checked: store.shouldRenameDefaultFolders })),
            store.hasUserChangedLanguage && (React.createElement(CommandButton, { text: isControlFeatureEnabled('fwk-localeHotReload')
                    ? strings.option_regional_languageHotReload
                    : strings.option_regional_languageReload, onClick: this.reloadPage, className: styles.reloadButton }))));
    };
    CultureSelection.prototype.toggleRenameFolders = function (ev, checked) {
        setRenameFoldersOption(checked);
    };
    CultureSelection.prototype.reloadPage = function () {
        location.reload();
    };
    CultureSelection.prototype.onSelectLocale = function (item) {
        selectLocaleOption(item.key);
    };
    CultureSelection = tslib_1.__decorate([
        observer
    ], CultureSelection);
    return CultureSelection;
}(React.Component));
export default CultureSelection;
//# sourceMappingURL=CultureSelection.js.map